import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Box,
  Typography,
  Link,
  Card,
  Fab,
  TextField,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import moment from "moment-timezone";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { AuthContext } from "../../../../context/AuthContext";
import { SnackAlertContext } from "../../../../context/SnackAlertContext";
import SelectPaymentMethod from "../../Invoices/SelectPaymentMethod";
import SelectDepositAccount from "../../Invoices/SelectDepositAccount";
import { LoadingButton } from "@mui/lab";

const ReceiveCashOrCheckPaymentDialog = ({
  currentInvoice,
  open,
  onClose,
  onSuccess,
}) => {
  const navigate = useNavigate();
  const { openSnackMessage } = useContext(SnackAlertContext);

  const { authToken, ezorder } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [paymentDate, setPaymentDate] = useState(moment());
  const [paymentAmount, setPaymentAmount] = useState(0);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [paymentReferenceNumber, setPaymentReferenceNumber] = useState(null);
  const [paymentDepositAccount, setPaymentDepositAccount] = useState(false);
  const [relatedInvoices, setRelatedInvoices] = useState([]);
  const [paymentLines, setPaymentLines] = useState([]);

  const handleClose = () => {
    onClose();
  };

  const handlePayment = async () => {
    try {
      setLoading(true);
      // TODO: check that payment lines added up is equal or greater than amount received
      const response = await ezorder.post(
        `/quickbooks/invoice/${currentInvoice.Id}/payments`,
        {
          paymentData: {
            paymentDate,
            paymentAmount,
            paymentMethod,
            paymentReferenceNumber,
            paymentDepositAccount,
            paymentLines,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status == 200 || response.status == 201) {
        console.log(response);
        openSnackMessage("success", "Payment received!");
        onSuccess();
      } else {
        console.log(response);
        openSnackMessage("error", response.response.data.error);
      }
    } catch (error) {
      console.log(error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        openSnackMessage("error", error.response.data.error);
      } else {
        // Something went really bad
        console.log(error);
        openSnackMessage("error", error);
      }
    } finally {
      setLoading(false);
    }
  };

  // const getPaymentMethods = async (controller) => {
  //   try {
  //     setLoading(true);
  //     let data = {
  //       headers: {
  //         Authorization: `Bearer ${authToken}`,
  //       },
  //     };
  //     if (controller) {
  //       data.signal = controller.signal;
  //     }

  //     const response = await ezorder.get(`/quickbooks/payment-methods`, data);

  //     setPaymentMethods(response.data.paymentMethods);
  //   } catch (error) {
  //     console.log("Failed To Load Payment Methods");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const getDepositAccounts = async (controller) => {
  //   try {
  //     setLoading(true);
  //     let data = {
  //       headers: {
  //         Authorization: `Bearer ${authToken}`,
  //       },
  //     };
  //     if (controller) {
  //       data.signal = controller.signal;
  //     }

  //     const response = await ezorder.get(`/quickbooks/accounts`, data);

  //     setDepositAccounts(response.data.accounts);
  //   } catch (error) {
  //     console.log("Failed To Load Payment Methods");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const getAllRelatedInvoicesByCustomer = async () => {
    try {
      setLoading(true);
      const response = await ezorder.get(
        `/quickbooks/invoice/${currentInvoice.Id}/related`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      console.log("Related Invoices", response.data.invoices);
      setRelatedInvoices(response.data.invoices);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const setDefaultPaymentLines = (mainInvoice) => {
    let mainInvoiceBalance = Number(mainInvoice.Balance);
    setPaymentLines([
      {
        ...mainInvoice,
        amountApplied: mainInvoiceBalance,
      },
    ]);
    setPaymentAmount(mainInvoiceBalance);
  };

  useEffect(() => {
    if (currentInvoice) {
      // getPaymentMethods();
      // getDepositAccounts();
      getAllRelatedInvoicesByCustomer();

      setDefaultPaymentLines(currentInvoice);
    }
  }, [currentInvoice]);

  if (!currentInvoice) return null;

  return (
    <Dialog
      fullScreen={true}
      fullWidth={true}
      open={open}
      onClose={() => {
        if (!loading) handleClose(); // do not allow close when loading
      }}
    >
      <DialogTitle> Receive Payment (Cash or Check)</DialogTitle>
      <DialogContent>
        <Box sx={{}}>
          <Box sx={{ paddingTop: "16px" }}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker
                sx={{ marginRight: "10px", marginBottom: "15px" }}
                format="MM/DD/YYYY"
                label="Date"
                value={paymentDate}
                onChange={(newValue) => {
                  setPaymentDate(newValue);
                }}
                renderInput={(params) => (
                  <TextField fullWidth sx={{}} size="small" {...params} />
                )}
              />
            </LocalizationProvider>
            <TextField
              size="small"
              sx={{ marginTop: "16px" }}
              label="Amount Received"
              type="number"
              fullWidth
              value={paymentAmount}
              onChange={(e) => {
                setPaymentAmount(e.target.value);
              }}
            />
            <Box sx={{ marginTop: "16px" }}>
              <SelectPaymentMethod
                size="small"
                onSelect={(paymentMethod) => {
                  setPaymentMethod(paymentMethod);
                }}
              />
            </Box>
            <TextField
              size="small"
              sx={{ marginTop: "16px" }}
              label="Reference no. (Check # for a Check, envelop # for a cash donation)"
              fullWidth
              value={paymentReferenceNumber}
              onChange={(e) => {
                setPaymentReferenceNumber(e.target.value);
              }}
            />
            <Box sx={{ marginTop: "16px" }}>
              <SelectDepositAccount
                size="small"
                onSelect={(account) => {
                  setPaymentDepositAccount(account);
                }}
              />
            </Box>
            <Typography sx={{ marginTop: "16px", fontWeight: "bold" }}>
              Apply Payment To Customer's Invoice(s)
            </Typography>
            <TableContainer sx={{ maxHeight: "400px", marginTop: "16px" }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ width: "50px" }}></TableCell>
                    <TableCell>Description</TableCell>
                    <TableCell>Original Amount</TableCell>
                    <TableCell>Current Balance</TableCell>
                    <TableCell>Due Date</TableCell>
                    <TableCell>Apply Payment</TableCell>
                  </TableRow>
                </TableHead>
                {paymentLines &&
                  paymentLines.map((line, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell sx={{ width: "50px" }}>
                          <Checkbox
                            style={{
                              magin: 0,
                              padding: 0,
                            }}
                            checked={true}
                            onChange={(e) => {
                              if (!e.target.checked) {
                                let paymentLinesCopy = [...paymentLines];
                                paymentLinesCopy.splice(index, 1);
                                setPaymentLines(paymentLinesCopy);
                              }
                            }}
                          />
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight:
                              line.Id == currentInvoice.Id ? "bold" : "inherit",
                          }}
                        >
                          Invoice #{line.DocNumber}
                          {" - "}
                          {line.CustomerRef.name ==
                          line.CustomerRef.parentRefName
                            ? line.CustomerRef.name
                            : `${line.CustomerRef.parentRefName} - ${line.CustomerRef.name}`}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight:
                              line.Id == currentInvoice.Id ? "bold" : "inherit",
                          }}
                        >
                          ${line.TotalAmt}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight:
                              line.Id == currentInvoice.Id ? "bold" : "inherit",
                          }}
                        >
                          ${line.Balance}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight:
                              line.Id == currentInvoice.Id ? "bold" : "inherit",
                          }}
                        >
                          {line
                            ? `${moment(line.DueDate).format("MM/DD/YY")}`
                            : "N/A"}
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight:
                              line.Id == currentInvoice.Id ? "bold" : "inherit",
                          }}
                        >
                          <TextField
                            label="Payment"
                            type="number"
                            value={line.amountApplied}
                            onChange={(e) => {
                              let paymentLinesCopy = [...paymentLines];
                              paymentLinesCopy[index].amountApplied =
                                e.target.value ?? Number(e.target.value);
                              setPaymentLines(paymentLinesCopy);
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {relatedInvoices &&
                  relatedInvoices.map((invoice, index) => {
                    if (
                      !paymentLines.find(
                        (paymentLine) => paymentLine.Id == invoice.Id
                      )
                    ) {
                      return (
                        <TableRow key={index}>
                          <TableCell sx={{ width: "50px" }}>
                            <Checkbox
                              style={{
                                magin: 0,
                                padding: 0,
                              }}
                              checked={
                                paymentLines.find(
                                  (paymentLine) => paymentLine.Id == invoice.Id
                                )
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                if (e.target.checked) {
                                  let paymentLinesCopy = [...paymentLines];
                                  setPaymentLines([
                                    ...paymentLinesCopy,
                                    { ...invoice, amountApplied: 0 },
                                  ]);
                                }
                              }}
                            />
                          </TableCell>
                          <TableCell
                            sx={{
                              fontWeight:
                                invoice.Id == currentInvoice.Id
                                  ? "bold"
                                  : "inherit",
                            }}
                          >
                            Invoice #{invoice.DocNumber}
                            {" - "}
                            {invoice.CustomerRef.name ==
                            invoice.CustomerRef.parentRefName
                              ? invoice.CustomerRef.name
                              : `${invoice.CustomerRef.parentRefName} - ${invoice.CustomerRef.name}`}
                          </TableCell>

                          <TableCell
                            sx={{
                              fontWeight:
                                invoice.Id == currentInvoice.Id
                                  ? "bold"
                                  : "inherit",
                            }}
                          >
                            ${invoice.TotalAmt}
                          </TableCell>
                          <TableCell
                            sx={{
                              fontWeight:
                                invoice.Id == currentInvoice.Id
                                  ? "bold"
                                  : "inherit",
                            }}
                          >
                            ${invoice.Balance}
                          </TableCell>
                          <TableCell
                            sx={{
                              fontWeight:
                                invoice.Id == currentInvoice.Id
                                  ? "bold"
                                  : "inherit",
                            }}
                          >
                            {invoice
                              ? `${moment(invoice.DueDate).format("MM/DD/YY")}`
                              : "N/A"}
                          </TableCell>
                        </TableRow>
                      );
                    }
                  })}
              </Table>
            </TableContainer>
            <Box>
              <Typography variant="h6" sx={{ textAlign: "right" }}>
                Total Applied $
                {paymentLines &&
                  paymentLines.reduce(
                    (accumulator, paymentLine) =>
                      accumulator + Number(paymentLine.amountApplied ?? 0),
                    0
                  )}
              </Typography>
            </Box>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          sx={{ marginRight: "8px" }}
          // variant="outlined"
          loading={loading}
          onClick={() => {
            onClose();
          }}
        >
          Cancel
        </LoadingButton>
        <LoadingButton
          color="success"
          // variant="contained"
          loading={loading}
          onClick={() => {
            handlePayment();
          }}
        >
          Save Payment
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
export default ReceiveCashOrCheckPaymentDialog;
